var map = {
	"./dashboard.svg": "./src/icons/svg/dashboard.svg",
	"./example.svg": "./src/icons/svg/example.svg",
	"./eye-open.svg": "./src/icons/svg/eye-open.svg",
	"./eye.svg": "./src/icons/svg/eye.svg",
	"./form.svg": "./src/icons/svg/form.svg",
	"./link.svg": "./src/icons/svg/link.svg",
	"./localitySkinAcne.svg": "./src/icons/svg/localitySkinAcne.svg",
	"./localitySkinCuticle.svg": "./src/icons/svg/localitySkinCuticle.svg",
	"./localitySkinElasticity.svg": "./src/icons/svg/localitySkinElasticity.svg",
	"./localitySkinHair.svg": "./src/icons/svg/localitySkinHair.svg",
	"./localitySkinOilContent.svg": "./src/icons/svg/localitySkinOilContent.svg",
	"./localitySkinSensitivity.svg": "./src/icons/svg/localitySkinSensitivity.svg",
	"./localitySkinSplotColor.svg": "./src/icons/svg/localitySkinSplotColor.svg",
	"./localitySkinWaterContent.svg": "./src/icons/svg/localitySkinWaterContent.svg",
	"./localitySkinWhiteness.svg": "./src/icons/svg/localitySkinWhiteness.svg",
	"./nested.svg": "./src/icons/svg/nested.svg",
	"./password.svg": "./src/icons/svg/password.svg",
	"./qianjin.svg": "./src/icons/svg/qianjin.svg",
	"./table.svg": "./src/icons/svg/table.svg",
	"./tree.svg": "./src/icons/svg/tree.svg",
	"./user.svg": "./src/icons/svg/user.svg",
	"./zhankai.svg": "./src/icons/svg/zhankai.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";